module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAABH0lEQVQ4je3ULUuDURjG8d90vm0KsyxYLDaDFvUDiHVgsNgEX8pmERTU6idYEMRkV7EaFMsQzTIMgtE68EE0bIY9G25s02dg2wWHi3Muzp/DzbnvWCJbgT2sY0B7vWMbNz8Pg3z7C7FEtrKEa1zhtQN8EeM4bZOXUcR5kFeGOObxgWVUOsDn8IADBC3yfoziBFvQp1qKr1/A8IgLlDCJFFJBvr7GcITNZM5EDR5FhyF0p01+GfoU1bJEURFn2EUGkrmGfCT04W7gsB9eTrTIYkjjOJkz0w38Dau1TfNXTOYs4B6ZqDX/i55DT/8HvK4evAePBv/EkO66tZUGQw/iuFNt51u8RCU1zRaYVp3thTgKWMMGZrt7bINKWAnynr4B/+Y5MfPcCAoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/file.png
// module id = g1gp
// module chunks = 1